const themes = {
  blue: {
    background: "#F1F2F8",
    sidebarBackground: "#FCF8F8",

    footerBackground: "#FFFFFF",
    navbarBackground: "#FFFFFF",
    navbarHover: "#F1F2F8",
    HeadersBackground: "#FFFFFF",
    contentBackground: "#FFFFFF",

    text: "#000000",
    sidebarText: "#0c0c0c",
    navbarText: "#000000",
    footerText: "#000000",
    footerTextSede: "#686565",
    TextWhite: "#FFFFFF",
    TextAlert: "#DA291C",

    tableHeader: "#545454",
    modalHeader: "#545454",
    modalOverlay: "rgba(0, 0, 0, 0.4)",

    inputBackground: "#1e3c72",

    toggleSi: "#EF9A9A",
    toggleNo: "#A5D6A7",
    toggleNeutro: "#CFD8DC",

    porcentaje1: "#00c853",
    porcentaje2: "#fdd835",
    porcentaje3: "#ffa000",
    porcentaje4: "#DA291C",

    // 404
    icon404: "#ff9800",
    colorPri404: "#ffcc00",
    colorSeg404: "#e6b800",


  },
};

export default themes;
